module.exports = __webpack_public_path__ + "static/prostate-101-banner-51189970b1bbbb4bb066860bac60e56d.png";